export default "/react/avito-ad00bbb1.svg";